import { motion } from "framer-motion";
import { LegalNotice } from "@/components/LegalNotice";
import { useI18n } from "@/i18n";
import { legalDoc } from "@/legalContent";

export default function Legal() {
  const { t, lang } = useI18n();
  return (
    <div data-testid="legal-page">
      <div className="max-w-5xl mx-auto px-5 sm:px-8 pt-14 pb-4">
        <motion.h1 initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }}
          className="font-display text-4xl sm:text-5xl font-black tracking-tighter text-[#2D231F]">
          {t("legal.pageTitle")}
        </motion.h1>
      </div>
      <LegalNotice withLink={false} />
      <div className="max-w-3xl mx-auto px-5 sm:px-8 py-14">
        <div className="bg-white rounded-2xl border border-[#EBDDD3] p-8 text-[#5A4B45] leading-relaxed whitespace-pre-line"
          data-testid="legal-terms-body">
          {legalDoc("terms", lang)}
        </div>
      </div>
    </div>
  );
}
